<template>
	<el-main class="userdetail">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>其他管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/asset' }">物品管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{ pathtype }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="form myform">
			<el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
				<div class="formtitle">物品管理</div>
				<div class="dividing-line">物品信息</div>
				<el-form-item label="物品类型：" prop="category_id">
					<el-col :span="12">
						<el-cascader v-model="form.category_ids" :options="officeTypeList"
							:props="{ expandTrigger: 'hover', checkStrictly: false }" @change="handleofficeChange"
							style="width: 100%;">
						</el-cascader>
					</el-col>
				</el-form-item>
				<el-form-item label="物品名称：" prop="asset_name">
					<el-col :span="5">
						<!-- 修复：恢复trigger-on-focus为true，保证下拉触发 -->
						<el-autocomplete v-model="form.asset_name" :fetch-suggestions="getAssetName" placeholder="请输入类别"
							:debounce="0" :loading="assetNameLoading" @input="handleAssetNameInput" @select="handleAssetNameSelect"
							@blur="handleAssetNameBlur" :trigger-on-focus="true" clearable style="width: 100%;">
						</el-autocomplete>
					</el-col>
					<el-col :span="1">&nbsp;</el-col>
					<el-col :span="6">
						<!-- 修复：恢复trigger-on-focus为true，核心触发下拉的属性 -->
						<el-autocomplete v-model="form.secondary_name" :fetch-suggestions="getSecondaryName" placeholder="请输入品牌-型号"
							:debounce="50" :loading="secondaryNameLoading" @input="handleSecondaryNameInput"
							@select="handleSecondaryNameSelect" :trigger-on-focus="true" clearable style="width: 100%;">
						</el-autocomplete>
					</el-col>
				</el-form-item>
				<el-form-item label="序列码：" prop="serial_no">
					<el-col :span="12">
						<el-input placeholder="请输入" maxlength="100" v-model="form.serial_no" clearable />
					</el-col>
				</el-form-item>
				<el-form-item label="规格型号：" prop="spec_model">
					<el-col :span="12">
						<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
							v-model="form.spec_model">
						</el-input>
					</el-col>
				</el-form-item>
				<!-- <el-form-item label="图片封面：" prop="img_name">
					<el-upload action="#" list-type="picture-card" :file-list="fileList" :auto-upload="false"
						:before-upload="beforeUpload" :on-change="imgchange">
						<i slot="default" class="el-icon-picture-outline dimg">
							<p>点击上传图</p>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.httpFile || file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
									<i class="el-icon-zoom-in"></i>
								</span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="" />
					</el-dialog>
				</el-form-item> -->
				<template>
					<ul class="anlist">
						<li v-for="(item, index) in fileList" :key="index">
							<div class="abox">
								<el-form-item :label='`新增图片${index + 1}：`'>
									<!-- 选择文件 -->
									<el-col :span="3" v-if="form.status != '5'">
										<el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
											:auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
											:on-change="(arg) => uploadFile_Job(arg, 'fileList', 'upFile', item, index)">
											<el-button size="small" style="width: 80px;">选择文件</el-button>
										</el-upload>
									</el-col>
									<!-- 文件预览及下载 -->
									<template v-if="item.origin_name">
										<el-col :span="10">
											<el-col :span="18">
												<div class="origin-name">{{
													item.origin_name }}</div>
											</el-col>
											<el-col :span="4">
												<el-link type="primary" style="margin-right:5px" :href="item.httpFile"
													target="_blank">查看</el-link>
											</el-col>
										</el-col>
									</template>
								</el-form-item>
							</div>
							<el-button class="bbtn" icon="el-icon-minus" @click="removeJob(fileList, index)" circle></el-button>

						</li>
						<el-button type="primary" style="margin: 0 0 15px 150px" class="addbtn"
							@click="addJob(fileList)">新增图片</el-button>
					</ul>
				</template>
				<el-form-item label="购置金额：" prop="asset_price">
					<el-col :span="12">
						<el-input type="number" placeholder="请输入" maxlength="100" v-model="form.asset_price" clearable />
					</el-col>
				</el-form-item>
				<el-form-item>
					<el-col :span="12">
						<el-alert title="用于财务登记固定资产原值" type="info" :closable="false"></el-alert>
					</el-col>
				</el-form-item>
				<el-form-item label="购置数量：" prop="asset_count">
					<el-col :span="12">
						<el-input placeholder="请输入" maxlength="100" v-model="form.asset_count" clearable />
					</el-col>
				</el-form-item>
				<el-form-item label="购置日期：" prop="purchase_date">
					<el-col :span="12">
						<el-date-picker v-model="form.purchase_date" type="datetime" value-format="yyyy-MM-dd" style="width: 100%;">
						</el-date-picker>
					</el-col>
				</el-form-item>
				<el-form-item label="物品归属：" prop="belong_type">
					<el-col>
						<el-radio-group v-model="form.belong_type" @change="belongChange">
							<el-radio label="1">项目</el-radio>
							<el-radio label="2">行政</el-radio>
						</el-radio-group>
					</el-col>
				</el-form-item>
				<div class="dividing-line">关联{{ dd.assetbelong_type[form.belong_type] }}</div>
				<el-form-item label="关联项目：" prop="project_id">
					<el-col :span="12">
						<el-select v-model="projectForm.project_id" placeholder="选择项目" style="margin-right: 0; width: 100%;"
							filterable clearable @change="projectChange">
							<el-option :label="v.item_no + ' ' + v.contract_name" :value="v.id" v-for="(v, i) in projectList"
								:key="`project_${i}`"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="关联子项目：" prop="sub_id">
					<el-col :span="12">
						<el-select v-model="projectForm.sub_id" placeholder="选择子项目" style="margin-right: 0; width: 100%;" filterable
							clearable @change="subChange">
							<el-option :label="v.contract_name" :value="v.id" v-for="(v, i) in subList" :key="`sub_${i}`"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="关联支出详情：" prop="project_pay_id">
					<el-col :span="12">
						<el-select v-model="projectForm.project_pay_id" placeholder="选择支出详情" style="margin-right: 0; width: 100%;"
							filterable clearable @change="payChange">
							<el-option :label="v.service_type_name + ' ' + v.vendor_name + ' ' + truncateString(v.service_info, 10)"
								:value="v.id" v-for="(v, i) in payList" :key="`pay_${i}`"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<div class="dividing-line"
					v-show="!projectForm.project_id && !projectForm.sub_id && !projectForm.project_pay_id">发票信息
				</div>
				<ul class="anlist" v-show="!projectForm.project_id && !projectForm.sub_id && !projectForm.project_pay_id">
					<li v-for="(item, index) in form.invoiceList" :key="index">
						<div class="abox">
							<el-form-item label="发票代码：" prop="invoice_code">
								<el-col :span="12">
									<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_code" clearable
										:disabled="(item.id && item.id != 0) && level != 1" />
								</el-col>
							</el-form-item>
							<el-form-item label="发票号码：" prop="invoice_no">
								<el-col :span="12">
									<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_no" clearable
										:disabled="(item.id && item.id != 0) && level != 1" />
								</el-col>
							</el-form-item>
							<el-form-item label="发票金额：" prop="invoice_amount">
								<el-col :span="12">
									<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_amount"
										@change="(v) => numberFn(v, item)" clearable :disabled="(item.id && item.id != 0) && level != 1" />
								</el-col>
							</el-form-item>
							<el-form-item label="发票日期：" prop="invoice_date">
								<el-col :span="5">
									<el-date-picker v-model="item.invoice_date" type="datetime" value-format="yyyy-MM-dd"
										:disabled="(item.id && item.id != 0) && level != 1" style="width: 100%;">
									</el-date-picker>
								</el-col>
							</el-form-item>
							<template>
								<ul class="anlist">
									<li v-for="(_it, _id) in item.atta_str" :key="`invoice-atta-${index}-${_id}`">
										<div class="abox">
											<el-form-item :label="`发票附件${_id + 1}：`">
												<el-col :span="3" v-if="(!_it.id && !_it.file_id)">
													<el-upload class="upload-demo" :ref="`upFile_${index}_${_id}`" action="#" :limit="1"
														:show-file-list="false" :auto-upload="false"
														accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="_it.flist"
														:on-change="(arg) => uploadFile(arg, item.atta_str, `$upFile_${index}_${_id}`, _it, _id)">
														<el-button size="small" style="width: 100%">选择文件</el-button>
													</el-upload>
												</el-col>
												<template v-if="_it.origin_name">
													<el-col :span="10">
														<el-col :span="18">
															<div class="origin-name">{{ _it.origin_name }}</div>
														</el-col>
														<el-col :span="4">
															<el-link type="primary" style="margin-right:5px" :href="_it.httpFile"
																target="_blank">查看</el-link>
														</el-col>
													</el-col>
												</template>
											</el-form-item>
										</div>
										<el-button class="bbtn" v-if="(!_it.id && !_it.file_id)" icon="el-icon-minus"
											@click="removeImage(item.atta_str, _id)" circle>
										</el-button>
									</li>
									<el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn"
										@click="addImage(item.atta_str)">新增发票附件</el-button>
								</ul>
							</template>
						</div>
						<el-button class="abtn" icon="el-icon-minus" @click="removeInvoice(form.invoiceList, index)" circle>
						</el-button>
					</li>
					<el-button type="primary" style="margin: 0 0 15px -5px;" class="addbtn"
						@click="addInvoice(form.invoiceList)">新增发票</el-button>
				</ul>
				<el-form-item label="是否消耗品：" prop="is_consumable">
					<el-col>
						<el-radio-group v-model="form.is_consumable">
							<el-radio label="0">否</el-radio>
							<el-radio label="1">是</el-radio>
						</el-radio-group>
					</el-col>
				</el-form-item>
				<el-form-item label="当前状态：" prop="status">
					<el-col>
						<el-radio-group v-model="form.status">
							<el-radio label="1">正常</el-radio>
							<el-radio label="2">维修</el-radio>
							<el-radio label="3">过期</el-radio>
							<el-radio label="4">部分过期</el-radio>
						</el-radio-group>
					</el-col>
				</el-form-item>
				<template v-if="form.status == '4'">
					<el-form-item label="过期数量：" prop="expired_count">
						<el-col :span="12">
							<el-input placeholder="请输入" maxlength="100" v-model="form.expired_count" clearable />
						</el-col>
					</el-form-item>
				</template>
				<el-form-item label="备注：" prop="remark">
					<el-col :span="12">
						<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
							v-model="form.remark">
						</el-input>
					</el-col>
				</el-form-item>
			</el-form>
			<div class="btnarea">
				<el-col :span="10">
					<el-button @click="resetForm('form')">取消</el-button>
					<el-button type="primary" @click="submitForm('form')">保存</el-button>
				</el-col>
			</div>
		</div>
	</el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'

export default {
	name: 'assetAdd',
	data() {
		return {
			returnUrl: true,
			nodeLimtList: [],
			level: '',
			userId: '',
			uid: '',
			itemList: [],
			officeTypeList: [],
			userArr: {},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 86400000;
				}
			},
			form: {
				asset_id: '',
				category_id: '',
				category_ids: [],
				belong_type: '2',
				is_consumable: '0',
				status: '1',
				invoiceList: [
					{
						invoice_no: '',
						invoice_code: '',
						invoice_amount: '',
						invoice_date: '',
						atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
					}
				],
				asset_name: '',
				secondary_name: ''
			},
			rules: {},
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			del_job_list: [],
			del_invoice_list: [],
			del_invoice_atta_list: [],
			fileList: [{ origin_name: '', httpFile: '', file_id: '' }],
			assetNameLoading: false,
			secondaryNameLoading: false,
			assetNamesList: [],
			secondaryNamesList: [],
			isInitCompleted: false,
			isManualChange: false,
			projectForm: {
				project_id: '',
				sub_id: '',
				project_pay_id: '',
			},
			projectList: [],
			subList: [],
			payList: [],
		}
	},
	computed: {},
	created() {
		this.query = this.$route.query
		this.getOfficeType().then(() => {
			this.loadAssetNameList('');
			if (this.query.id) {
				this.getDetail(this.query.id);
			} else {
				this.isInitCompleted = true;
			}
		})
	},
	mounted() {

	},
	watch: {
		'form.asset_name'() {
			if (this.isManualChange && this.isInitCompleted) {
				this.clearSecondaryInfo(true);
			}
		}
	},
	methods: {
		clearSecondaryInfo(clearInput = false) {
			if (clearInput) {
				this.form.secondary_name = '';
			}
			this.secondaryNamesList = [];
		},
		loadAssetNameList(keyword) {
			this.assetNameLoading = true;
			this.$fly.post("ApiAsset_getAssetNames.html", { asset_name: keyword || '' })
				.then((res) => {
					this.assetNameLoading = false;
					this.assetNamesList = res?.length ? res.map(item => ({
						value: item.asset_name || item.name || item.value || '',
						...item
					})) : [];
				})
				.catch((err) => {
					this.assetNameLoading = false;
					console.error('加载物品名称失败：', err);
					this.assetNamesList = [];
				});
		},
		handleAssetNameInput(val) {
			this.isManualChange = true;
			this.loadAssetNameList(val);
		},
		handleAssetNameSelect(selectedItem) {
			this.isManualChange = true;
			this.form.asset_name = selectedItem.value;
			this.clearSecondaryInfo(true);
			// 强制触发二级列表加载，保证下拉有数据
			this.loadSecondaryNameList(this.form.secondary_name, this.form.asset_name);
		},
		handleAssetNameBlur() {
			if (this.isInitCompleted) {
				this.isManualChange = true;
				this.clearSecondaryInfo(true);
				this.loadSecondaryNameList(this.form.secondary_name, this.form.asset_name);
			}
		},
		getAssetName(queryString, callback) {
			if (callback) {
				const filterList = this.assetNamesList.filter(item =>
					item.value.toLowerCase().includes(queryString.toLowerCase())
				);
				callback(filterList);
			}
		},
		loadSecondaryNameList(keyword, assetName) {
			this.secondaryNameLoading = true;
			this.$fly.post("ApiAsset_getSecondaryNames.html", {
				asset_name: assetName || this.form.asset_name,
				secondary_name: keyword || ''
			})
				.then((res) => {
					this.secondaryNameLoading = false;
					this.secondaryNamesList = res?.length ? res.map(item => ({
						value: item.secondary_name || item.name || item.value || '',
						...item
					})) : [];
				})
				.catch((err) => {
					this.secondaryNameLoading = false;
					console.error('加载二级名称失败：', err);
					this.secondaryNamesList = [];
				});
		},
		// 修复：输入时立即加载列表，保证下拉有数据
		handleSecondaryNameInput(val) {
			if (this.form.asset_name) { // 必须有物品名称才加载
				this.loadSecondaryNameList(val, this.form.asset_name);
			}
		},
		handleSecondaryNameSelect(selectedItem) {
			this.form.secondary_name = selectedItem.value;
		},
		// 修复：确保fetch-suggestions能正确返回过滤后的列表
		getSecondaryName(queryString, callback) {
			if (callback) {
				const filterList = this.secondaryNamesList.filter(item =>
					item.value.toLowerCase().includes(queryString.toLowerCase())
				);
				// 强制触发回调，保证下拉显示
				callback(filterList);
			}
		},
		checkUrlFn() {
			const hash = window.location.hash;
			const url = hash.substring(1);
			let postData = { url_path: url }
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({ type: 'info', message: '暂无权限' });
					this.$router.push({ path: '/home' });
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = { menu_id };
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		link(url) {
			this.$router.push(url)
		},
		getUserDetail(uid) {
			this.$fly.post('ApiStaffReimbursement_getStaffInfo.html', { uid }).then((res) => {
				this.userArr = res
			})
		},
		getOfficeType() {
			const that = this;
			return new Promise(function (resolve) {
				that.$fly.post("apiAsset_getAssetTypeDownList.html", {}).then((res) => {
					that.officeTypeList = res.length ? res : [];
					resolve(that.officeTypeList)
				});
			})
		},
		getDetail(id) {
			api.getAssetInfo({ asset_id: id }).then((res) => {
				const {
					asset_name, secondary_name, serial_no, spec_model, asset_price,
					asset_count, purchase_date, belong_type, is_consumable, status,
					expired_count, remark, category, category_id, category_ids, project_pay_id,
				} = res;
				this.form = {
					...this.form,
					asset_name, secondary_name, serial_no, spec_model, asset_price,
					asset_count, purchase_date, belong_type, is_consumable, status,
					expired_count, remark, category, category_id, category_ids, project_pay_id,
				};
				const {
					project_id,
					son_project_id,
					pay_id,
				} = res.project_pay_info
				this.projectForm = {
					project_id,
				}
				this.getProjectList(belong_type)
				this.projectChange(project_id)
				this.projectForm = {
					...this.projectForm,
					sub_id: son_project_id,
				}
				this.subChange(son_project_id)
				this.projectForm = {
					...this.projectForm,
					project_pay_id: pay_id,
				}
				const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }];
				this.form.invoiceList = res.invoiceList?.map((item) => {
					item.invoice_date = timeFormat(item.invoice_date);
					item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str();
					return item;
				});
				if (res.invoiceList?.length == 0) {
					this.form.invoiceList = [{
						invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '',
						atta_str: atta_str()
					}];
				}
				// this.fileList = res.file_list;
				this.fileList = res.file_list?.map(({ origin_name, file_name, httpFile, id }) => {
         return { origin_name, file_name, httpFile, file_id: id, fileList: [] }
        })
				this.loadAssetNameList(this.form.asset_name);
				this.clearSecondaryInfo(false);
				// 编辑态加载二级列表，保证下拉有数据
				this.loadSecondaryNameList(this.form.secondary_name, this.form.asset_name);
				this.getStoreFn();
				this.isInitCompleted = true;
				this.isManualChange = false;
			})
		},
		getStoreFn() {
			this.checkUrlFn();
			this.checkNodeFn('61');
			setTimeout(() => {
				this.level = store.state.level;
				this.userId = store.state.userId;
			}, 200);
		},
		numberFn(v, item) {
			v = v.toString().replace(/,/g, "");
			item.invoice_amount = v;
		},
		addJob(arr) {
			arr.push({
				origin_name: '', file_name: '', httpFile: '', file_id: '', flist: []
			});
		},
		removeJob(arr, index) {
			if (arr[index].file_id) {
				this.del_job_list.push(arr[index].file_id);
			}
			console.log(this.del_job_list);
			arr = arr.splice(index, 1);
		},
		uploadFile_Job(file, fileList, ref, item, index) {
			let formData = new FormData();
			formData.append("file_arr", file.raw);
			formData.append("type", 7);
			api.uploadFile(formData)
				.then((res) => {
					this[fileList][index] = {
						...item,
						origin_name: res.origin_name,
						file_name: res.file_name,
						httpFile: res.httpFile,
					}
					this.$forceUpdate()
					this.$refs[ref][index].clearFiles();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		uploadFile(file, fileList, ref, item, index) {
			let formData = new FormData();
			formData.append("file_arr", file.raw);
			formData.append("type", 7);
			api.uploadFile(formData)
				.then((res) => {
					fileList[index] = {
						...item,
						origin_name: res.origin_name,
						file_name: res.file_name,
						httpFile: res.httpFile,
					}
					this.$forceUpdate()
					this.$refs[ref][0].clearFiles();
				})
				.catch((err) => {
					console.log(err);
				});
		},
		addImage(arr) {
			arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
			this.$forceUpdate();
		},
		removeImage(arr, index) {
			if (!this.del_invoice_atta_list) this.del_invoice_atta_list = [];
			if (arr[index].id) this.del_invoice_atta_list.push(arr[index].id);
			arr.splice(index, 1);
			this.$forceUpdate();
		},
		addInvoice(arr) {
			arr.push({
				invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '',
				atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }],
			});
		},
		removeInvoice(arr, index) {
			if (arr[index] && arr[index].id) {
				this.del_invoice_list.push(arr[index].id);
			}
			arr.splice(index, 1);
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) this.addUpdateAsset();
				else console.log('error submit!!');
			})
		},
		addUpdateAsset() {
			this.form.asset_id = this.query.id || '';
			this.form.option = this.form.asset_id ? '2' : '1';
			if (this.projectForm.project_id) {
				if (!this.projectForm.sub_id) {
					this.$message.error('请完善关联项目')
					return false
				}
				else {
					if (!this.projectForm.project_pay_id) {
						this.$message.error('请完善关联项目')
						return false
					}
				}
			}
			console.log(this.projectForm.project_pay_id);
			this.form.project_pay_id = this.projectForm.project_pay_id
			const $invoiceList = this.form.invoiceList?.map((item) => {
				Object.keys(item).forEach(key => {
					if (key === 'id') {
						item.invoice_id = item[key] || 0;
						delete item[key];
					}
				});
				item.atta_str = item.atta_str?.map((it) => {
					delete it.flist;
					delete it.httpFile;
					Object.keys(it).forEach(_key => {
						if (_key === 'id') {
							it.file_id = it[_key] || 0;
							delete it[_key];
						}
					});
					return it;
				});
				return item;
			});
			this.form.invoiceList = $invoiceList;
			const $fileList = this.fileList?.map((item) => {
				Object.keys(item).forEach(key => {
					if (key === 'id') {
						item.file_id = item[key] || 0;
						delete item[key];
					}
				});
				return item;
			});
			const tempForm = JSON.parse(JSON.stringify(this.form));
			tempForm.img_str = JSON.stringify($fileList);
			tempForm.invoice_str = JSON.stringify(tempForm.invoiceList);
			delete tempForm.category;
			delete tempForm.invoiceList;
			const url = 'apiAsset_addUpdateAsset';
			this.$fly.post(url, {
				...tempForm,
				invoice_del: this.del_invoice_list.toString(),
				img_del: this.del_job_list.toString(),
			}).then(() => {
				this.$router.go(-1);
			});
		},
		resetForm(formName) {
			this.returnUrl = false;
			this.$refs[formName].resetFields();
			this.$router.go(-1);
		},
		handleofficeChange(v) {
			if (v && v.length) {
				const trueId = v[v.length - 1];
				this.form.category_id = trueId;
				this.form.category_ids = v;
			}
		},
		beforeUpload(file) {
			this.fileList = [];
			console.log(file);
		},
		imgchange(file) {
			file.id = this.fileList[0]?.id || this.fileList[0]?.file_id || '';
			this.fileList = [];
			this.checkImg(file.url, file);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.httpFile || file.url;
			this.dialogVisible = true;
		},
		uploadImage(dataURL, file) {
			api.uploadImage({ img: dataURL, type: 7 }).then((res) => {
				this.fileList = [{
					file_id: file.id || '',
					origin_name: file.name,
					file_name: res.img_name,
					httpFile: res.httpImg
				}];
			});
		},
		checkImg(url, file) {
			const img = new Image();
			img.src = url;
			img.onload = function () {
				let dataURL = '';
				let canvas = document.createElement('canvas');
				let width = img.width;
				let height = img.height;
				canvas.width = width;
				canvas.height = height;
				canvas.getContext('2d').drawImage(img, 0, 0, width, height);
				dataURL = canvas.toDataURL('image/png');
				this.uploadImage(dataURL, file);
			}.bind(this);
		},
		projectChange(v) {
			this.projectForm.sub_id = ''
			this.projectForm.project_pay_id = ''
			if (this.projectForm.project_id) {
				this.getSubList(v)
			}
		},
		subChange(v) {
			this.projectForm.project_pay_id = ''
			if (this.projectForm.sub_id) {
				this.getPayList(v)
			}
		},
		payChange(v) {
			this.form.project_pay_id = v
			console.log(this.form.project_pay_id);
		},
		async getProjectList(belong_type) {
			this.$fly.post('ApiAsset_getAdminProjectList.html', {
				m_type: belong_type
			})
				.then((res) => {
					this.projectList = res
				})
		},
		getSubList(id) {
			this.$fly.post('ApiAsset_getSubProjectList.html', {
				project_id: id
			})
				.then((res) => {
					this.subList = res
				})
		},
		getPayList(id) {
			this.$fly
				.post('ApiAsset_getProjectPayList.html', {
					son_project_id: id,
				})
				.then((res) => {
					this.payList = res.length ? res : []
				})
		},
		belongChange(v) {
			this.projectForm.project_id = ''
			this.projectForm.sub_id = ''
			this.projectForm.project_pay_id = ''
			this.getProjectList(v)
		},
		// 直接在methods中定义函数
		truncateString(text, maxLength = 10) {
			const str = typeof text === 'string' ? text : String(text || '')
			if (maxLength <= 0) return '...'
			return str.length > maxLength ? str.slice(0, maxLength) + '...' : str
		}
	}
}
</script>

<style lang="scss" scoped>
.userdetail {
	.form.myform {
		padding-left: 100px;
	}

	.form {
		@extend %box;
		padding: 60px;
		margin-bottom: 20px;

		.anlist {
			padding: 0;
			flex-flow: column nowrap;

			li {
				position: relative;
				padding: 0;
				list-style: none;

				.abtn {
					position: absolute;
					top: 0;
					left: 65%;
				}

				.bbtn {
					position: absolute;
					top: 0;
					left: 60%;
				}
			}
		}
	}

	.formtitle {
		position: relative;
		left: -50px;
		margin-bottom: 30px;
		font-size: 28px;
		line-height: 48px;
		font-weight: 600;
	}
}

.dividing-line {
	font: 600 24px/1 $font;
	padding: 40px 0;
}
</style>